var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","right":"16px","bottom":"56px","height":"56px","width":"56px","background-color":"white","border-radius":"28px","box-shadow":"1px 1px 20px #888888"},on:{"click":_vm.handleClick}},[_c('img',{staticStyle:{"height":"48px","width":"48px","margin-left":"4px","margin-top":"4px"},attrs:{"src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }